import React from 'react';

export class TableBody extends React.Component<React.PropsWithChildren> {
  public render() {
    return <tbody>{this.props.children}</tbody>;
  }
}

export default TableBody;
